<template>
    <div id="modals">
        <projectSelector></projectSelector>
        <ConfirmProjectSwitch />
        <NonExportableTool />
        <ColourMatchToolNotice />

        <modalResetScene />
        <modalNewImage />
        <modalNewCandidate />

        <modalCreateCustomLutsFolder />
        <modalImportCustomLuts />
        <modalEditCustomLuts />
        <modalRenameCustomLutsFolder />
        <modalRenameCustomLut />
        <modalDeleteCustomCategory />
        <modalDeleteCustomLut />

        <CustomLutV2CreateLutFolder />
        <CustomLutV2ImportLut />
        <CustomLutV2EditLut />
        <CustomLutV2RenameLutFolder />
        <CustomLutV2RenameLut />
        <CustomLutV2DeleteLutFolder />
        <CustomLutV2DeleteLut />

        <modalNewMatch />

        <modalColorWorkflowNotification />
        <modalBinCreate />
        <modalBinEdit />
        <modalBinDelete />
		<modalTrashEmpty />

        <createProject />
        <deleteProject />
        <assignProject />
        <ProjectMembersModal />

        <fileCopyTo />
        <FailedProcessing />
        <FailedUploading />
        <copyCandidateFrom />
        <applyGradeTo />
        <applyGradeFrom />

        <createLayout />
        <deleteLayout />
        <renameLayout />

        <createPreset />
        <deletePreset />
        <deletePresetFolder />
        <importPreset />
        <presetFileTypeNotSupported />
        <presetInvalidChecksum />
        <presetTransformsMismatch />
        <presetNonColourManagedWorkflow />

        <ColourMatch />
        <ColourMatchV2 />
        <AdvancedColourMatchV2 />
        <AIColourExtract />
        <AIColourExtractV2 />
        <AIColourMatchModal />
        <AIColourMatchV2Modal />

        <NotAvailableInFree />

        <ViewCommentUpload />

        <PurchaseProduct />

        <SaveAllAsCandidatesProcessing />
        <SaveAllAsCandidatesUnprocessedList />

        <CompareView />

        <NeuralToneAIProcessing />
        <NeuralToneAIUnprocessedList />

        <NeuralFilmAIProcessing />
        <NeuralFilmAIUnprocessedList />

        <ErrorWhileFetchingProjects />
    </div>
</template>

<script>
import ConfirmProjectSwitch from '@/components/app/projects/ConfirmProjectSwitch';
import modalResetScene from "@/views/templates/modals/reset-scene";
import modalNewImage from "@/views/templates/modals/new-image";
import modalNewCandidate from "@/views/templates/modals/new-candidate";

import modalCreateCustomLutsFolder from "@/views/templates/modals/create-custom-luts-folder";
import modalImportCustomLuts from "@/views/templates/modals/import-custom-luts";
import modalEditCustomLuts from "@/views/templates/modals/edit-custom-luts";
import modalRenameCustomLutsFolder from "@/views/templates/modals/rename-custom-luts-folder";
import modalRenameCustomLut from "@/views/templates/modals/rename-custom-lut";
import modalDeleteCustomCategory from "@/views/templates/modals/delete-custom-luts-folder";
import modalDeleteCustomLut from "@/views/templates/modals/delete-custom-lut";

import CustomLutV2CreateLutFolder from "@/views/templates/modals/CustomLutV2/CreateLutFolder.vue";
import CustomLutV2ImportLut from "@/views/templates/modals/CustomLutV2/ImportLut.vue";
import CustomLutV2EditLut from "@/views/templates/modals/CustomLutV2/EditLut.vue";
import CustomLutV2RenameLutFolder from "@/views/templates/modals/CustomLutV2/RenameLutFolder.vue";
import CustomLutV2RenameLut from "@/views/templates/modals/CustomLutV2/RenameLut.vue";
import CustomLutV2DeleteLutFolder from "@/views/templates/modals/CustomLutV2/DeleteLutFolder.vue";
import CustomLutV2DeleteLut from "@/views/templates/modals/CustomLutV2/DeleteLut.vue";

import modalNewMatch from "@/views/templates/modals/new-match";
import modalColorWorkflowNotification from "@/views/templates/modals/color-workflow-notification";
import modalBinCreate from "@/views/templates/modals/bin-create";
import modalBinEdit from "@/views/templates/modals/bin-edit";
import modalBinDelete from "@/views/templates/modals/bin-delete";
import modalTrashEmpty from "@/views/templates/modals/trash-folder-empty.vue"

import fileCopyTo from "@/components/app/files/CopyTo";
import FailedProcessing from "@/components/app/files/modals/FailedProcessing";
import FailedUploading from "@/components/app/files/modals/FailedUploading";
import copyCandidateFrom from "@/components/app/files/CopyCandidateFrom.vue";
import applyGradeTo from "@/components/app/grade/ApplyGradeTo.vue";
import applyGradeFrom from "@/components/app/grade/ApplyGradeFrom.vue";

import NonExportableTool from "@/components/app/blocks/warnings/NonExportableTool.vue";
import ColourMatchToolNotice from "@/components/app/blocks/warnings/ColourMatchToolNotice.vue";

import createLayout from "@/components/app/layouts/Create";
import deleteLayout from "@/components/app/layouts/Delete";
import renameLayout from "@/components/app/layouts/Rename";

import createPreset from "@/components/app/presets/CreatePreset.vue";
import deletePreset from "@/components/app/presets/DeletePreset.vue";
import deletePresetFolder from "@/components/app/presets/DeletePresetFolder.vue";
import importPreset from "@/components/app/presets/ImportPreset.vue";
import presetFileTypeNotSupported from "@/components/app/presets/warnings/FileTypeNotSupported";
import presetInvalidChecksum from "@/components/app/presets/warnings/InvalidChecksum";
import presetTransformsMismatch from "@/components/app/presets/warnings/TransformsMismatch";
import presetNonColourManagedWorkflow from "@/components/app/presets/warnings/NonColourManagedWorkflow";

import projectSelector from "@/components/app/projects/Projects";
import createProject from "@/components/app/projects/Create";
import deleteProject from "@/components/app/projects/Delete";
import assignProject from "@/components/app/projects/Assign";
import ProjectMembersModal from "@/components/app/projects/ProjectMembersModal";

import ColourMatch from "@/components/app/blocks/ColourMatch/V1/ColourMatchModal.vue";
import ColourMatchV2 from "@/components/app/blocks/ColourMatch/V2/ColourMatchV2Modal.vue";
import AdvancedColourMatchV2 from "@/components/app/blocks/ColourMatch/V2/AdvancedColourMatchV2Modal.vue";
import AIColourExtract from "@/components/app/blocks/AIColourExtract/V1/AIColourExtractModal";
import AIColourExtractV2 from "@/components/app/blocks/AIColourExtract/V2/AIColourExtractModal";
import AIColourMatchModal from "@/components/app/blocks/AIColourMatch/V1/AIColourMatchModal.vue";
import AIColourMatchV2Modal from "@/components/app/blocks/AIColourMatch/V2/AIColourMatchV2Modal.vue";
import NotAvailableInFree from "@/views/templates/modals/not-available-in-free";

import ViewCommentUpload from "@/views/templates/modals/view-comment-upload"
import PurchaseProduct from "@/views/templates/modals/product-purchase";
import CompareView from '@/views/templates/modals/compare-view'
import NeuralToneAIProcessing from '@/views/templates/modals/NeuralToneAIProcessing.vue'
import NeuralToneAIUnprocessedList from '@/views/templates/modals/NeuralToneAIUnprocessedList.vue'
import NeuralFilmAIProcessing from '@/views/templates/modals/NeuralFilmAIProcessing.vue'
import NeuralFilmAIUnprocessedList from '@/views/templates/modals/NeuralFilmUnprocessedList.vue'

import SaveAllAsCandidatesProcessing from '@/views/templates/modals/SaveAllAsCandidatesProcessing';
import SaveAllAsCandidatesUnprocessedList from '@/views/templates/modals/SaveAllAsCandidatesUnprocessedList';
import ErrorWhileFetchingProjects from "@/views/templates/modals/error-while-fetching-projects.vue";

export default {
    name: "Modals",
    components: {
        NotAvailableInFree,
        ConfirmProjectSwitch,
        NonExportableTool,
        ColourMatchToolNotice,

        modalResetScene,
        modalNewImage,
        modalNewCandidate,

        modalCreateCustomLutsFolder,
        modalImportCustomLuts,
        modalEditCustomLuts,
        modalRenameCustomLutsFolder,
        modalRenameCustomLut,
        modalDeleteCustomCategory,
        modalDeleteCustomLut,

        CustomLutV2CreateLutFolder,
        CustomLutV2ImportLut,
        CustomLutV2EditLut,
        CustomLutV2RenameLutFolder,
        CustomLutV2RenameLut,
        CustomLutV2DeleteLutFolder,
        CustomLutV2DeleteLut,

        modalNewMatch,
        modalColorWorkflowNotification,

        modalBinCreate,
        modalBinEdit,
        modalBinDelete,
		modalTrashEmpty,

        fileCopyTo,
        copyCandidateFrom,
        applyGradeTo,
        applyGradeFrom,
        FailedProcessing,
        FailedUploading,

        createLayout,
        deleteLayout,
        renameLayout,

        createPreset,
        deletePreset,
        deletePresetFolder,
        importPreset,
        presetFileTypeNotSupported,
        presetInvalidChecksum,
        presetTransformsMismatch,
        presetNonColourManagedWorkflow,

        projectSelector,
        createProject,
        deleteProject,
        assignProject,
        ProjectMembersModal,

        ColourMatch,
        ColourMatchV2,
        AdvancedColourMatchV2,
        AIColourExtract,
        AIColourExtractV2,
        AIColourMatchModal,
        AIColourMatchV2Modal,

        ViewCommentUpload,
        PurchaseProduct,
        CompareView,

        SaveAllAsCandidatesProcessing,
        SaveAllAsCandidatesUnprocessedList,
        NeuralToneAIProcessing,
        NeuralToneAIUnprocessedList,
        NeuralFilmAIProcessing,
        NeuralFilmAIUnprocessedList,
        ErrorWhileFetchingProjects,
    }
}
</script>